var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 295,
    viewBox: "0 0 402 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.406 147.698L0 0.275391H121.606L244.28 147.698L121.606 294.579H0L118.406 147.698Z",
    fill: "#2B5CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.423 294.581L275.829 139.101L401.703 139.1L279.029 294.581H157.423Z",
    fill: "#2B5CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksIcon);
export default __webpack_public_path__ + "static/media/howItWorksIcon.4f4a88afc5df6e10fdd7c74e800bc2f8.svg";
export { ForwardRef as ReactComponent };